<script setup>
import {onMounted, ref, inject, watch} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import {getLogo} from "@/helpers/logo";
import {startupStatusClasses, startupStatusLabels} from "@/constants/needs";

const need = inject('need');
const updateStartups = inject('updateStartups');
const startups = ref([]);

watch(updateStartups, (value) => {
    if (value) {
        getStartups();
    }
});

onMounted(() => {
    getStartups();
});

async function getStartups() {
    const {data} = await needsService.getSubmittedStartups(need.value.id);
    startups.value = data;
}
</script>

<template>
    <div v-if="startups.length" class="dashboard-page__card need-admin__card--double">
        <div class="dashboard-page__card__inner">
            <h3 class="dashboard-page__title dashboard-page__title--ai">Submitted Startups</h3>

            <div class="dashboard-page__table dashboard-page__table-flexible">
                <table>
                    <tbody>
                    <tr v-for="startup in startups" :key="startup.id">
                        <td class="pl-0">
                            <div class="dashboard-page__table__title">
                                <div class="data-labels-set data-labels-set--lg">
                                    <span class="data-label data-label--lightning">
                                        <img :src="getLogo(startup.logo)"/>
                                    </span>
                                </div>
                                <div>
                                    <h6 class="heading6"><a :href="`/startups/${startup.id}`" target="_blank">{{ startup.name }}</a></h6>
                                </div>
                            </div>
                        </td>
                        <td class="text-right">
                            Submitted {{ startup.submitted_at }}
                        </td>
                        <td class="pr-0">
                            <div class="status-plate-wrapper justify-content-end">
                                <span class="status-plate status-plate--strong" :class="startupStatusClasses[startup.status]">{{ startupStatusLabels[startup.status] }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
